import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOff, Wifi } from 'lucide-react';
import { useNetworkStatus } from '../utils/offlineHandler';

export default function OfflineNotification() {
  const isOnline = useNetworkStatus();
  const [showNotification, setShowNotification] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    // ONLY show notification for actual network offline (not Firebase errors)
    const shouldShow = !isOnline;
    
    if (shouldShow) {
      setShowNotification(true);
      setWasOffline(true);
    } else if (wasOffline) {
      // Show "back online" message briefly
      setTimeout(() => {
        setShowNotification(false);
        setWasOffline(false);
      }, 3000);
    } else {
      setShowNotification(false);
    }
  }, [isOnline, wasOffline]);

  // Network offline - Red notification
  if (!isOnline) {
    return (
      <AnimatePresence>
        {showNotification && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md px-4"
          >
            <div className="bg-red-500 text-white rounded-lg shadow-xl p-4 flex items-center gap-3">
              <WifiOff className="h-6 w-6 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-semibold">No Internet Connection</p>
                <p className="text-sm text-red-100">
                  Please check your network settings.
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  // Back online - Green notification
  if (wasOffline && isOnline) {
    return (
      <AnimatePresence>
        {showNotification && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md px-4"
          >
            <div className="bg-green-500 text-white rounded-lg shadow-xl p-4 flex items-center gap-3">
              <Wifi className="h-6 w-6 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-semibold">Back Online!</p>
                <p className="text-sm text-green-100">
                  Connection restored successfully.
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return null;
}
